import { defineStore } from 'pinia'

import state from './router.state'
import getters from './router.getters'
import actions from './router.actions'

/**
 * Returns the router store
 */
export const useRouterStore = defineStore('router', {
  state: () => state,
  getters,
  actions
})
